import React from "react";

import { TextInput } from "react-admin";

const serviceTemplateFilters = [
  <TextInput label="common.search" source="q" alwaysOn resettable autoFocus />,
];

export default serviceTemplateFilters;
